import React from 'react'
import Header from '../Component/Header';
import 'bootstrap/dist/css/bootstrap.min.css';
import Herosection from '../Component/Herosection';
import "boxicons/css/boxicons.min.css";
import WhyChooseUs from '../Component/Whychooseus';
import OurCourse from '../Component/OurCourse';
import FAQ from '../Component/FAQ';
import Testimonials from '../Component/Testimonials';
import About from '../Component/About';
import Footer from '../Component/Footer';
// import Placed from '../Component/Placed';
import Blog from '../Component/Blog';
import EnquiryPopup from '../Component/Enquirypopup';
function Index() {
    return (
        <div>
            <EnquiryPopup />
            <Header />
            <Herosection />
            <OurCourse />
            <WhyChooseUs />
            <About />
            {/* <FAQ/> */}
            <FAQ />
            <Testimonials />
            {/* <Placed /> */}
            <Blog />
            <Footer />
        </div>
    )
}

export default Index